module.exports = __webpack_public_path__ + "static/img/payment.e5b691b.svg";